/*
 * Copyright (c) 2018 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of 2018 SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	DocumentComboControl.js
 *
 * Description:	JavaScript to encapsulate the combo control functionality.
 *
 */

/*
 *	Combo Control Constants.
 */
c_szComboControlIcon_Light = "img/Arrow_Down_16.png";
c_szComboControlIcon_Dark = "img/Arrow_Down_White_16.png";
c_szComboControlClearIcon_Light = "img/Cancel-Close_16.png";
c_szComboControlClearIcon_Dark = "img/Cancel-Close_wht_16.png";
c_szComboControlThreeDIcon = "img/3DGlasses.png";
c_szComboControlArchivedIcon = "img/imagenotavailable.png";
var c_szApprovedIcon = "img/Complete-Task_24.png";
var c_szPendingIcon = "img/Approval-In-Progress_24.png";
var c_szRejectedIcon = "img/Reject-01_24.png";
var c_szAwaitingMyApprovalIcon = "img/Awaiting_My_Review_24.png";

/*
 *	Combo Control Resx Strings.
 */
g_oComboControls = {
    c_szFilterDocuments: "",
    c_szPage: "",
    c_szGoToPage: "",
    c_szAnnotationCount: ""
};

/*
 * Combo Control List.
 */
var g_oaComboControls = [];

/*
 * Combo Control Creation.
 */
function comboControl_CreateNewControl(id, fieldId, prompt, documents, mandatory, onChangeFunction, placeholder, deselectionPlaceholder, filterMode) {

    // Create the new combo control.
    var oControl = new comboControl(id, fieldId, prompt, mandatory, onChangeFunction, placeholder, deselectionPlaceholder, filterMode);

    // Add the combo box to the list.
    var iControlIndex = g_oaComboControls.push(oControl) - 1;

    // Add each of the documents to the combo control.
    for (var i = 0; i < documents.length; i++) {
        comboControl_AddDocument(iControlIndex, documents[i]);
    }

    // Render the new combo control.
    comboControl_Render(iControlIndex);

    // Return the index of the combo box.
    return iControlIndex;
}

function comboControl(id, fieldId, prompt, mandatory, onChangeFunction, placeholder, deselectionPlaceholder, filterMode) {
    this.id = id;
    this.fieldId = fieldId;
    this.selectedDocumentIndex = -1;
    this.selectedPageIndex = -1;
    this.prompt = prompt;
    this.mandatory = mandatory;
    this.onChangeFunction = onChangeFunction;
    this.placeholder = placeholder;
    this.deselectionPlaceholder = deselectionPlaceholder;
    this.filterMode = filterMode;
    this.listOpen = false;
    this.readOnly = false;
    this.documents = [];
}

function comboControl_Remove(controlId) {
    g_oaComboControls.splice(controlId, 1);
}

/*
 *	Combo Control Functionality.
 */
function comboControl_Render(controlId) {

    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];

    // If the control has been found.
    if (typeof oComboControl != "undefined") {

        // Declare a variable to hold the HTMl content.
        var szHTML = "";

        // If this control has a prompt.
        if (oComboControl.prompt != "") {

            // Add the combo control prompt div to hold the prompt.
            szHTML += "<div id='divComboControlPrompt_" + controlId + "' class='comboControlPrompt'>";
            szHTML += "<table tblComboControlPrompt_" + controlId + " cellspacing='0' cellpadding='0' style='height: 100%;'>";
            szHTML += "<tr><td>" + oComboControl.prompt + ":</td></tr>";
            szHTML += "</table>";
            szHTML += "</div>";
        }

        // Add a combo control div to hold the selected value.
        szHTML += "<div id='divComboControl_" + controlId + "' class='comboControl' onclick='comboControl_ToggleList(" + controlId + ");'>";
        szHTML += "<table id='tblComboControl_" + controlId + "' cellspacing='0' cellpadding='0' style='height: 100%;'><tr>";
        szHTML += "<td id='tdComboControl_" + controlId + "'>" + oComboControl.placeholder + "</td>";
        szHTML += "<td><img id='imgComboControlDropDown_" + controlId + "' style='vertical-align: middle; padding-left: 4px; padding-right: 12px;' src='" + (g_oSettings.c_iSkinType == 0 ? c_szComboControlIcon_Dark : c_szComboControlIcon_Light) + "' /></td>";
        szHTML += "</tr></table>";
        szHTML += "</div>";

        // Add the combo control list div that will drop down.
        szHTML += "<div id='divComboControlList_" + controlId + "' class='comboControlList' style='display:none;'>";

        // Apply the HTML, then render the icon once finished.
        $("#" + oComboControl.fieldId).html(szHTML);

        // Update the above lock setting of the combo control.
        comboControl_UpdateAboveLock(controlId);
    }
}

function comboControl_AddDocument(controlId, document) {

    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];

    // Get the index of the next document.
    var iIndex = oComboControl.documents.length;

    // Add the document to the list.
    oComboControl.documents[iIndex] = document;
}

function comboControl_ToggleList(controlId) {

    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];

    // Only perform the toggle if the list is not read only.
    if (!oComboControl.readOnly) {

        // If the list is currently closed.
        if (!oComboControl.listOpen) {

            // Open the list.
            comboControl_OpenList(controlId);
        }
        // If the list is currently open.
        else {

            // Close the list.
            comboControl_CloseList(controlId);
        }
    }
}

function comboControl_OpenList(controlId) {

    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];

	// Update the position of the combo control list to match the left position of the parent combo control.
	$("#divComboControlList_" + controlId).css("left", Math.round($("#divComboControl_" + controlId).position().left));
	$("#divComboControlList_" + controlId).css("top", Math.round($("#divComboControl_" + controlId).position().top + $("#divComboControl_" + controlId).height()));

    // Render the combo control options.
    comboControl_RenderOptions(controlId);

    // Hide any other drop down content menus.
    $(".dropdown-content:visible").slideToggle(200);

    // Show the combo control list.
    $("#divComboControlList_" + controlId).animate({ height: "toggle" }, 600);

    // Recalculate the page annotation numbers.
    g_oAnnotations.renderPageAnnotationNumbers();

    // Set that the list is now open.
    oComboControl.listOpen = true;
}

function comboControl_CloseList(controlId) {

    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];

    // Hide the combo control list.
    $("#divComboControlList_" + controlId).animate({ height: "toggle" }, 600);

    // Set that the list is now closed.
    oComboControl.listOpen = false;
}

function comboControl_RenderOptions(controlId) {

    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];

    // Declare a variable to hold the HTML content.
    var szHTML = "";

    // Add a table to hold each of the documents.
    szHTML += "<table id='tblComboControlList_" + controlId + "' cellspacing='0' cellpadding='0' style='width: 100%;'>";

    // If this control is not mandatory.
    if (!oComboControl.mandatory) {

        // Show the row if a document is currently selected.
        var bShowClearOption = (oComboControl.selectedDocumentIndex != -1);

        // Add a row to allow deselection of a document.
        szHTML += "<tr id='trComboControlClear_" + controlId + "' style='" + (bShowClearOption ? "" : "display: none;") + "'><td style='padding: 4px;'>";
        szHTML += "<table cellspacing='0' cellpadding='0' onclick='comboControl_ClearOption(" + controlId + ", true);' style='width: 100%; cursor: pointer;'><tr>";
        szHTML += "<td><img src='" + (g_oSettings.c_iSkinType == 0 ? c_szComboControlClearIcon_Dark : c_szComboControlClearIcon_Light) + "' style='vertical-align: middle;'></td>";
        szHTML += "<td>" + oComboControl.deselectionPlaceholder + "</td>";
        szHTML += "</tr></table>";
        szHTML += "</td></tr>";
    }

    // Add a row to allow searching of the documents.
    szHTML += "<tr><td style='padding: 4px;'>";
    szHTML += "<input id='txtComboControlListFilter_" + controlId + "' type='text' class='comboControlFilter' onKeyUp='comboControl_FilterDocuments(" + controlId + ");' placeholder=' " + g_oComboControls.c_szFilterDocuments + "' />";
    szHTML += "</td></tr>";

    var iThreeDViewParentDocumentId = -1;

    // Check if a ThreeDView for the current document has been selected
    if (oComboControl.selectedDocumentIndex > -1) {
        var oSelectedDocumentApproval3DViewId = oComboControl.documents[oComboControl.selectedDocumentIndex].document.Approval3DViewId;
        if (oSelectedDocumentApproval3DViewId > 0) {
            iThreeDViewParentDocumentId = g_oThreeDView.GetThreeDView(oSelectedDocumentApproval3DViewId).ParentDocumentId;
        }
    }

    // Loop through each of the documents in the control.
    for (var i = 0; i < oComboControl.documents.length; i++) {

        // Extract the current document.
        var oDocument = oComboControl.documents[i];

        // Check if this is the currently selected document or we have selected a 3D View and this is the 3D Views parent document.
        var bSelectedDocument = (i == oComboControl.selectedDocumentIndex) || oDocument.greenlightDocumentId === iThreeDViewParentDocumentId;

        // Create a row for the document.
        szHTML += "<tr><td>";

        // Add the document details to a table.
        szHTML += "<table id='tblComboDocument_" + i + "' cellspacing='0' cellpadding='0' class='" + (bSelectedDocument ? "comboControlListOptionSelected" : "comboControlListOption") + "' onclick='comboControl_SelectOption(" + controlId + ", " + i + ", -1, true);' style='position: relative;'>";
        szHTML += "<tr>";

        // Add the document image.
        szHTML += "<td class='comboControlListOptionImageHolder'><img class='comboControlListOptionImage' src='" + comboControl_GetDocumentThumbnailPath(oDocument.document) + "' /></td>";

        // Add the document name.
        szHTML += "<td colspan='3' class='comboControlListOptionText'>" + oDocument.documentName + comboControl_RenderDocumentBadge(oDocument.document) + "</td>";

        // Close the table for the document details.
        szHTML += "</tr>";

        var szApprovalDisplayStatus = "";
        var szApprovalIcon = "";

        if (oDocument.greenlightApprovalId > 0) {
            switch (oDocument.greenlightApprovalDisplayStatus) {
                case eApprovalStatus.Pending:
                    szApprovalDisplayStatus = g_oAnnotations.c_szPending;
                    szApprovalIcon = c_szPendingIcon;
                    break;
                case eApprovalStatus.AwaitingMyReview:
                    szApprovalDisplayStatus = g_oAnnotations.c_szAwaitingMyApproval;
                    szApprovalIcon = c_szAwaitingMyApprovalIcon;
                    break;
                case eApprovalStatus.Rejected:
                    szApprovalDisplayStatus = g_oAnnotations.c_szRejected;
                    szApprovalIcon = c_szRejectedIcon;
                    break;
                case eApprovalStatus.Approved:
                    szApprovalDisplayStatus = g_oAnnotations.c_szApproved;
                    szApprovalIcon = c_szApprovedIcon;
                    break;
                default:
                    break;
            }
        }

        if (oDocument.document.pages.length > 1 || szApprovalDisplayStatus !== "") {

            szHTML += "<tr>";

            // Hide this row if there are no approval statuses or the approval information is set to be hidden.
            if (szApprovalDisplayStatus !== "" && !g_oApproval.g_bApprovalInformationHidden) {
                // Add an icon to show what state the document currently is (approved/rejected/pending/awaiting my review)
                szHTML += "<tr><td class='comboControlListOptionApprovalState'>";
                szHTML += "<td id='comboControlListOptionApprovalStateIcon' width='30'><img width='24' src=\"" + szApprovalIcon + "\"></img></td>";
                szHTML += "<td id='comboControlListOptionApprovalStateIcon'>" + szApprovalDisplayStatus + "</td>";
                szHTML += "</td></tr>";
            }

            // If this is a multi page document.
            if (oDocument.document.pages.length > 1) {

                // Determine the selected page number.
                var iPageNumber = 1;

                // If this is the currently selected document and we have a selected page.
                if (bSelectedDocument && oComboControl.selectedPageIndex != -1) {

                    // Extract the selected page number.
                    iPageNumber = oDocument.document.pages[oComboControl.selectedPageIndex].documentPageNumber;
                }

                // Add an option to allow page selection.
                szHTML += "<td colspan='3'><div id='divComboDocumentPageSelection_" + i + "' class='' style='float:right; " + (bSelectedDocument ? "" : "display: none;") + "'>";
                szHTML += g_oComboControls.c_szGoToPage + ":&nbsp;";
                szHTML += "<input id='txtComboDocumentPageSelection_" + i + "' class='comboControlPageFilter' type='text' size='2' onclick='event.stopPropagation();' onKeyUp='comboControl_ValidatePageSelection(event, " + controlId + ", " + i + ")' placeholder='" + iPageNumber + "' />";
                szHTML += "</div></td>";
            }


            szHTML += "</tr>";
        }

        szHTML += "</table>";

        var iOptionsPagesIndex = i;
        // If there are more documents and the next document is a 3dView.
        if ((i + 1) <= oComboControl.documents.length - 1 && oComboControl.documents[i + 1].document.Approval3DViewId > 0) {

            // Determine if the parent document is archived.
            var bParentDocumentArchived = oComboControl.documents[i].document.documentStatus == g_oArchive.g_ArchivedDocumentStatus;
            // Add a div and table to hold each of the documents pages.
            szHTML += "<div id='divComboDocumentThreeDView_" + (i) + "' style='" + (bSelectedDocument ? "" : "display: none;") + "'><table cellspacing='0' cellpadding='0' style='width: 283px;'>";
            // Switch index to the next index as it is the 3D Preview.
            i++;
            // Add HTML for the 3D Previews
            szHTML += comboControl_RenderOptionsThreeDPreviews(controlId, i, bParentDocumentArchived);
            // Close the table and div holding the documents 3D Views.
            szHTML += "</table></div>";
            // Move index to the next none threeDView
            for (var j = i; j < oComboControl.documents.length; j++) {
                if (oComboControl.documents[j].document.Approval3DViewId > 0) {
                    i++;
                }
                else {
                    break;
                }
            }
            // Need to move back one as index gets moved to the next at start of loop.
            i--;
        }

        // If this document has pages.
        if (oDocument.document.pages.length > 1) {

            // Render the document pages.
            szHTML += comboControl_RenderOptionsPages(controlId, iOptionsPagesIndex);
        }

        // Close the row for the document.
        szHTML += "</td></tr>";
    }

    // Close the table holding the documents.
    szHTML += "</table>";

    // Apply the HTML.
    $("#divComboControlList_" + controlId).html(szHTML);
}

function comboControl_RenderOptionsThreeDPreviews(controlId, documentIndex, parentIsArchived) {

    var bEven = true;
    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];
    // Declare a variable to hold the HTML content.
    var szHTML = "";
    var iModelNumber = 1;
    var iCount = 0;
    // Add all 3DView mini views
    while (oComboControl.documents[documentIndex] && oComboControl.documents[documentIndex].document.Approval3DViewId > 0) {

        // Get the document using the document id.
        var oDocument = oComboControl.documents[documentIndex];

        // Check if this is the currently selected document.
        var bSelectedDocument = (documentIndex == oComboControl.selectedDocumentIndex);

        // If this is an even 3D Preview.
        if (bEven) {

            // Create a row for the 3D Preview.
            szHTML += "<tr>";
        }
        // Create a section for the 3D Preview.
        szHTML += "<td>";

        // Set the onclick of the ThreeD preview.
        var szThreeDPreviewOnClick = "comboControl_SelectOption(" + controlId + ", " + documentIndex + ", " + -1 + ", true)";

        // If the parent document is archived, override the onclick of the ThreeDPreview.
        if (parentIsArchived) {
            szThreeDPreviewOnClick = 'g_oGreenlightMessages.displayErrorBubble("Please select the parent document first as this document has been archived.");';
		}

        // If we are only adding a single 3D preview render with 50% width
        if ((iCount === 0 && !oComboControl.documents[documentIndex+1]) || (iCount === 0  && oComboControl.documents[documentIndex+1].document.Approval3DViewId === -1)) {
            // Add the 3D Preview details to a table.
            szHTML += "<table style='width: 50%; table-layout: fixed;' id='tblComboDocumentThreeDPreview_" + documentIndex + "' cellspacing='0' cellpadding='0' class='" + (bSelectedDocument ? "comboControlListOptionSelected" : "comboControlListOption") + "' onclick='" + szThreeDPreviewOnClick + "'>";
        }
        else {
            // Add the 3D Preview details to a table.
            szHTML += "<table style='width: 100%; table-layout: fixed;' id='tblComboDocumentThreeDPreview_" + documentIndex + "' cellspacing='0' cellpadding='0' class='" + (bSelectedDocument ? "comboControlListOptionSelected" : "comboControlListOption") + "' onclick='" + szThreeDPreviewOnClick + "'>";
        }
        iCount++;
        szHTML += "<tr>";
        szHTML += "<td class='comboControlListOptionImageHolder'><img class='comboControlListOptionImageSmall' src='" + comboControl_GetDocumentThumbnailPath(oDocument.document) + "' /></td>";
        szHTML += "<td class='comboControlListOptionText' style='word-break: initial;'>";
        szHTML += "<table>";
        //If there's more than one page add page numbers
        var oThreeDView = g_oThreeDView.GetThreeDView(oDocument.document.Approval3DViewId);

        var oParentDoc = $.findfirst(oComboControl.documents, function (x) {
                                return x.greenlightDocumentId === oThreeDView.ParentDocumentId;
                            });
        var iParentPageNumber = $.findfirst(oParentDoc.document.pages, function (x) {
                                    return x.documentPageId === oThreeDView.ParentDocumentPageId;
                                }).documentPageNumber;
        if (iParentPageNumber > 1) {
            szHTML += "<tr><td>3D Preview Page " + iParentPageNumber + "</td></tr>";
        }
        else {
            szHTML += "<tr><td>3D Preview</td></tr>";
        }

        szHTML += "</table>";
        szHTML += "</td>";
        szHTML += "</tr>";
        szHTML += "</table>";


        // Close the section for the 3D Preview.
        szHTML += "</td>";

        if (!bEven) {
            // Close the row for the 3D Preview.
            szHTML += "</tr>";
            bEven = true;
        }
        else {
            bEven = false;
        }
        iModelNumber++;
        documentIndex++;
    }
    // Close the final row
    if (!bEven) {
        szHTML += "</tr>";
    }
    return szHTML;
}

function comboControl_RenderOptionsPages(controlId, documentId) {

    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];

    // Get the document using the document id.
    var oDocument = oComboControl.documents[documentId];

    // Check if this is the currently selected document.
    var bSelectedDocument = (documentId == oComboControl.selectedDocumentIndex);

    // Check if a ThreeDView for the current document has been selected
    if (oComboControl.selectedDocumentIndex > -1) {
        var oSelectedDocumentApproval3DViewId = oComboControl.documents[oComboControl.selectedDocumentIndex].document.Approval3DViewId;
        if (oSelectedDocumentApproval3DViewId > 0) {
            var oThreeDView = g_oThreeDView.GetThreeDView(oSelectedDocumentApproval3DViewId);
            if (oThreeDView.ParentDocumentId === oDocument.greenlightDocumentId) {
                bSelectedDocument = true;
            }
        }
    }

    // Declare a variable to hold the HTML content.
    var szHTML = "";

    // Add a div and table to hold each of the documents pages.
    szHTML += "<div id='divComboDocumentPages_" + documentId + "' style='" + (bSelectedDocument ? "" : "display: none;") + "'><table cellspacing='0' cellpadding='0' style='width: 100%;'>";
    if (oComboControl.documents[documentId].document.documentType === 1 || oComboControl.documents[documentId].document.documentType === 4) { // If its a pdf do for loop below
        // Loop through each of the pages in the document.
        for (var i = 0; i < oDocument.document.pages.length; i++) {

            // Extract the current page.
            var oPage = oDocument.document.pages[i];

            // Check if this is the currently selected page.
            var bSelectedPage = (documentId == oComboControl.selectedDocumentIndex) && (i == oComboControl.selectedPageIndex);

            // Check if this page is odd or even.
            var bEven = i % 2 == 0;

            // If this is an even page.
            if (bEven) {

                // Create a row for the page.
                szHTML += "<tr>";
            }

            // Create a section for the page.
            szHTML += "<td>";

            // Add the page details to a table.
            szHTML += "<table id='tblComboDocumentPage_" + i + "' cellspacing='0' cellpadding='0' class='" + (bSelectedPage ? "comboControlListOptionSelected" : "comboControlListOption") + "' onclick='comboControl_SelectOption(" + controlId + ", " + documentId + ", " + i + ", true);'>";
            szHTML += "<tr>";
            szHTML += "<td class='comboControlListOptionImageHolder'><img class='comboControlListOptionImageSmall' src='" + oPage.documentThumbPath + "' /></td>";
            szHTML += "<td class='comboControlListOptionText' style='word-break: initial;'>";
            szHTML += "<table>";
            szHTML += "<tr><td>" + g_oComboControls.c_szPage + " " + oPage.documentPageNumber + "</td></tr>";
            szHTML += "<tr id='trComboDocumentPage_" + i + "_annotationNumber' style='display: none;'><td align='right'>";
            szHTML += "<span id='spnComboDocumentPage_" + i + "_annotationNumberText' class='annotationNumbersForPage tooltip' title='" + g_oComboControls.c_szAnnotationCount + "'>0</span>";
            szHTML += "</td></tr>";
            szHTML += "</table>";
            szHTML += "</td>";
            szHTML += "</tr>";
            szHTML += "</table>";

            // Close the section for the page.
            szHTML += "</td>";

            // If this is an odd page, or the last page.
            if (!bEven || i + 1 == oDocument.document.pages.length) {

                // Close the row for the page.
                szHTML += "</tr>";
            }
        }
    }

    // Close the table and div holding the documents pages.
    szHTML += "</table></div>";

    // Return the HTML content.
    return szHTML;
}

function comboControl_SelectOption(controlId, documentIndex, pageIndex, fireOnChange) {
    
    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];

    // Store the currently selected options.
    var iOldSelectedDocumentIndex = oComboControl.selectedDocumentIndex;
    var iOldSelectedPageIndex = oComboControl.selectedPageIndex;

    // Determine if the select list should be prevented from closing.
    var bPreventClose = false;

    // Get the document using the document id.
    var oDocument = oComboControl.documents[documentIndex];

    // If we are in a text compare, and have only opted to change page, use the text compare page change function to keep the document settings.
    if (g_oTextCompare.g_bTextCompareInProgress && iOldSelectedDocumentIndex == documentIndex && iOldSelectedPageIndex != pageIndex && fireOnChange) {
        g_oTextCompare.changeToPage(pageIndex + 1, oComboControl.id == "approvalCompareComboControl");
        return;
	}

    // De-Select 3Dview.
    if (iOldSelectedDocumentIndex > -1 && oComboControl.documents[iOldSelectedDocumentIndex].document.Approval3DViewId > 0) {
        // Remove the selection from the combo control option.
        $("#tblComboControlList_" + controlId + " #tblComboDocumentThreeDPreview_" + iOldSelectedDocumentIndex).addClass("comboControlListOption").removeClass("comboControlListOptionSelected");

        // Set the selection back to the combo control placeholder.
        $("#tblComboControl_" + controlId + " #tdComboControl_" + controlId).html(oComboControl.placeholder);
        // Set that the document has been deselected.
        oComboControl.selectedDocumentIndex = -1;
        // If a different document is selected.
        if (oComboControl.documents[documentIndex].document.Approval3DViewId === -1) {
            var oThreeDView = g_oThreeDView.GetThreeDView(oComboControl.documents[iOldSelectedDocumentIndex].document.Approval3DViewId);
            var oParentIndex = -1;
            for (var i = 0; i < oComboControl.documents.length; i++) {
                if (oComboControl.documents[i].greenlightDocumentId === oThreeDView.ParentDocumentId) {
                    oParentIndex = i;
                    break;
                }
            }
            // If parent is different parent hide 3D preview list
            if (oParentIndex !== documentIndex) {
                $("#tblComboControlList_" + controlId + " #divComboDocumentThreeDView_" + oParentIndex).animate({ height: "toggle" }, 600);
                // Remove the selection from the combo control option.
                $("#tblComboControlList_" + controlId + " #tblComboDocument_" + oParentIndex).addClass("comboControlListOption").removeClass("comboControlListOptionSelected");
                // If new doc has threeDViews prevent closing and expand list for new document.
                if ($.findfirst(g_oThreeDView.g_oApprovalThreeDViews, function (x) {
                        return x.ParentDocumentId === oComboControl.documents[documentIndex].greenlightDocumentId;
                    })) {
                    var bPreventClose = true;
                    $("#tblComboControlList_" + controlId + " #divComboDocumentThreeDView_" + documentIndex).animate({ height: "toggle" }, 600);
                }
                // If old doc has pages hide them
                if (oComboControl.documents[oParentIndex].document.pages.length > 1) {
                    // Hide the document pages list.
                    $("#tblComboControlList_" + controlId + " #divComboDocumentPages_" + oParentIndex).animate({ height: "toggle" }, 600);
                    // Hide the document page selection option.
                    $("#tblComboControlList_" + controlId + " #divComboDocumentPageSelection_" + oParentIndex).hide();
                }
            }
        }
    }
    else if (oDocument != null && oDocument.document.Approval3DViewId === -1 && g_oThreeDView.g_oApprovalThreeDViews) {

        // Check if document has any three D Views to prevent closing
        var bThreeDView = $.findfirst(g_oThreeDView.g_oApprovalThreeDViews, function (x) {
                                return x.ParentDocumentId === oDocument.greenlightDocumentId;
                            }) ? true : false;

        if (bThreeDView) {
            var bPreventClose = true;
        }
        if (iOldSelectedDocumentIndex > -1) {
            if (oComboControl.documents[iOldSelectedDocumentIndex].document.Approval3DViewId === -1 && iOldSelectedDocumentIndex !== documentIndex) {
                $("#tblComboControlList_" + controlId + " #divComboDocumentThreeDView_" + iOldSelectedDocumentIndex).animate({ height: "toggle" }, 600);
                $("#tblComboControlList_" + controlId + " #divComboDocumentThreeDView_" + documentIndex).animate({ height: "toggle" }, 600);
            }
            else if (iOldSelectedDocumentIndex === documentIndex && pageIndex !== iOldSelectedPageIndex) {
                // Same document different page
                var bPreventClose = false;
            }
        }
        else {
            // Expand to show 3D Views
            $("#tblComboControlList_" + controlId + " #divComboDocumentThreeDView_" + documentIndex).animate({ height: "toggle" }, 600);
        }
    }

    // If this document has pages and a specific page has not been selected.
    if (oDocument != null && oDocument.document.pages.length > 1 && pageIndex == -1) {

        // If the selected document has been changed.
        if (documentIndex != iOldSelectedDocumentIndex) {

            // Select the first page by default.
            pageIndex = 0;

            // Prevent the list from auto closing when this is not an archived document.
            bPreventClose = true;

            // If this document is not mandatory.
            if (!oComboControl.mandatory) {

                // Show the clear control option.
                $("#trComboControlClear_" + controlId).show();
            }
        }
        // If the selected document has not been changed.
        else {

            // Keep the same page index.
            pageIndex = oComboControl.selectedPageIndex;
        }
    }

    // If the selected page has changed.
    if (pageIndex != oComboControl.selectedPageIndex || documentIndex != oComboControl.selectedDocumentIndex) {

        // If this control already has a selected page.
        if (oComboControl.selectedPageIndex != -1) {

            // Deselect the current page.
            comboControl_DeselectOption(controlId, oComboControl.selectedDocumentIndex, oComboControl.selectedPageIndex);
        }

        // If a page has been selected.
        if (pageIndex != -1) {

            // Add the selection to the new page.
            $("#tblComboControlList_" + controlId + " #divComboDocumentPages_" + documentIndex + " #tblComboDocumentPage_" + pageIndex).addClass("comboControlListOptionSelected").removeClass("comboControlListOption");

            // Update the placeholder of the go to page box.
            $("#tblComboControlList_" + controlId + " #txtComboDocumentPageSelection_" + documentIndex).attr("placeholder", + oDocument.document.pages[pageIndex].documentPageNumber + "");
        }

        // Set that the document has been selected.
        oComboControl.selectedPageIndex = pageIndex;
    }

    // If the selected document has changed.
    if (documentIndex != oComboControl.selectedDocumentIndex) {

        // If this control already has a selected document and is a 3dView.
        if (oDocument.document.Approval3DViewId > 0 && oComboControl.selectedDocumentIndex != -1) {

            var oThreeDView = g_oThreeDView.GetThreeDView(oDocument.document.Approval3DViewId);
            var ILastSelectedDocumentId = oComboControl.documents[oComboControl.selectedDocumentIndex].greenlightDocumentId;
            if (oThreeDView && oThreeDView.ParentDocumentId === ILastSelectedDocumentId) {
                // Remove the selection from the combo control option.
                $("#tblComboControlList_" + controlId + " #tblComboDocument_" + oComboControl.selectedDocumentIndex).addClass("comboControlListOption").removeClass("comboControlListOptionSelected");

                // Set the selection back to the combo control placeholder.
                $("#tblComboControl_" + controlId + " #tdComboControl_" + controlId).html(oComboControl.placeholder);

                // Set that the document has been deselected.
                oComboControl.selectedDocumentIndex = -1;
            }
            else {
                comboControl_DeselectOption(controlId, oComboControl.selectedDocumentIndex, -1);
            }
        }
        else if (oComboControl.selectedDocumentIndex != -1) {
                // Deselect the current document.
                comboControl_DeselectOption(controlId, oComboControl.selectedDocumentIndex, -1);
        }

        // Add the selection to the new document.
        $("#tblComboControlList_" + controlId + " #tblComboDocument_" + documentIndex).addClass("comboControlListOptionSelected").removeClass("comboControlListOption");

        // Set that the document has been selected.
        oComboControl.selectedDocumentIndex = documentIndex;

        // If this document has pages and the page section is not already expanded.
        if (oDocument.document.pages.length > 1 && $("#tblComboControlList_" + controlId + " #divComboDocumentPages_" + documentIndex).css("display") == "none") {

            // Determine the selected page number.
            var iPageNumber = 1;

            // If this is the currently selected document and we have a selected page.
            if (oComboControl.selectedPageIndex != -1) {

                // Extract the selected page number.
                iPageNumber = oDocument.document.pages[oComboControl.selectedPageIndex].documentPageNumber;
            }

            // Show the document page selection option.
            $("#tblComboControlList_" + controlId + " #divComboDocumentPageSelection_" + documentIndex).show();

            // Expand the document pages list.
            $("#tblComboControlList_" + controlId + " #divComboDocumentPages_" + documentIndex).animate({ height: "toggle" }, 600);
        }
    }

    // If the selection has been changed.
    if (oComboControl.selectedDocumentIndex != iOldSelectedDocumentIndex || oComboControl.selectedPageIndex != iOldSelectedPageIndex) {

        // If a page selection has been made.
        if (oComboControl.selectedDocumentIndex != -1 && oComboControl.selectedPageIndex != -1) {

            // Set the selection to the current document name and page number.
            $("#tblComboControl_" + controlId + " #tdComboControl_" + controlId).html(oComboControl.documents[oComboControl.selectedDocumentIndex].documentName + " (Page " + oComboControl.documents[oComboControl.selectedDocumentIndex].document.pages[oComboControl.selectedPageIndex].documentPageNumber + ")");
        }
        // If a document selection has been made.
        else if (oComboControl.selectedDocumentIndex != -1) {

            // Set the selection to the current document name.
            $("#tblComboControl_" + controlId + " #tdComboControl_" + controlId).html(oComboControl.documents[oComboControl.selectedDocumentIndex].documentName);
        }

        // Call the update function if set and required.
        if (!isNothing(oComboControl.onChangeFunction) && fireOnChange) {
            eval(oComboControl.onChangeFunction);
        }

        // Render document selection display.
        g_oApprovalFiles.Setup(controlId);
    }

    // If they are not selecting a pdf document then hide the ThreeDView option.
    if (!(g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex].document.documentType === 1)) {
        $('#btnThreeDViewer').hide();
    }
    else {
        var iGreenlightDocumentPageIndex = (g_oaComboControls[0].selectedPageIndex === -1) ? 0 : g_oaComboControls[0].selectedPageIndex;
        // Show only if currently selected page has a trim box and we aren't in compare mode.
        if (g_oViewer.g_oCompareMode === eCompareMode.NoCompare && g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex].document.pages[iGreenlightDocumentPageIndex].trimBox > 0 && (g_oThreeDView.g_oConsumerModelTemplates && g_oThreeDView.g_oConsumerModelTemplates[0])) {
            if (g_oThreeDView.g_bCreateThreeDPreviews) {
                $('#btnThreeDViewer').show();
            }
        }
        else {
            $('#btnThreeDViewer').hide();
        }
    }

    // We always force a close when a document is in the archived state, as this will need to be unarchived.
    if (bPreventClose && oComboControl.documents[oComboControl.selectedDocumentIndex].document.documentStatus == g_oArchive.g_ArchivedDocumentStatus) {
        bPreventClose = false;
	}

    // If the control list is currently open and we are not preventing closing of the list.
    if (oComboControl.listOpen && !bPreventClose) {

        // Close the list.
        comboControl_CloseList(controlId);
    }

    // If the selected document has not been viewed before, mark this as viewed.
    if (oComboControl.documents[oComboControl.selectedDocumentIndex].document.documentViewed == false) {
        comboControl_MarkDocumentAsViewed(oComboControl.documents[oComboControl.selectedDocumentIndex].document);
	}
}

function comboControl_DeselectOption(controlId, documentIndex, pageIndex) {

    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];

    // Get the document using the document id.
    var oDocument = oComboControl.documents[documentIndex];

    // If we are deselecting a page.
    if (pageIndex != -1) {

        // Remove the selection from the combo control option.
        $("#tblComboControlList_" + controlId + " #divComboDocumentPages_" + documentIndex + " #tblComboDocumentPage_" + pageIndex).addClass("comboControlListOption").removeClass("comboControlListOptionSelected");

        // Set that the page has been deselected.
        oComboControl.selectedPageIndex = -1;

        // Update the placeholder of the go to page box.
        $("#tblComboControlList_" + controlId + " #txtComboDocumentPageSelection_" + documentIndex).attr("placeholder", "1");
    }
    // If we are deselecting a document.
    else if (documentIndex != -1) {

        // Remove the selection from the combo control option.
        $("#tblComboControlList_" + controlId + " #tblComboDocument_" + documentIndex).addClass("comboControlListOption").removeClass("comboControlListOptionSelected");

        // Set the selection back to the combo control placeholder.
        $("#tblComboControl_" + controlId + " #tdComboControl_" + controlId).html(oComboControl.placeholder);

        // Set that the document has been deselected.
        oComboControl.selectedDocumentIndex = -1;
        // If this document has pages and the page section is not already collapsed.
        if (oDocument.document.pages.length > 1 && $("#tblComboControlList_" + controlId + " #divComboDocumentPages_" + documentIndex).css("display") == "block") {

            // Hide the document page selection option.
            $("#tblComboControlList_" + controlId + " #divComboDocumentPageSelection_" + documentIndex).hide();

            // Hide the document pages list.
            $("#tblComboControlList_" + controlId + " #divComboDocumentPages_" + documentIndex).animate({ height: "toggle" }, 600);
        }
    }
}

function comboControl_ClearOption(controlId, fireOnChange) {

    // Do not allow clearing of the combo control when in text compare mode.
    if (g_oTextCompare.g_bTextCompareInProgress) {

        // Exit the text compare.
        g_oTextCompare.resetDifferences();
        g_oTextCompare.storeActiveTextSelectionGroups();
        g_oTextCompare.hideTextCompareInformation();
        g_oTextCompare.hideTextCompareSeparations();
        g_oTextCompare.hideTextCompareDiv();
        g_oCompare.exitTextCompareMode();
	}

    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];

    // If there is currently a selected page.
    if (oComboControl.selectedPageIndex != -1) {

        // Deselect the page.
        comboControl_DeselectOption(controlId, oComboControl.selectedDocumentIndex, oComboControl.selectedPageIndex);
    }

    // Deselect the document.
    comboControl_DeselectOption(controlId, oComboControl.selectedDocumentIndex, -1);

    // Hide the clear control option.
    $("#trComboControlClear_" + controlId).hide();
    $("#ApprovalFileSelect_" + controlId).hide();

    // Set the selection back to the placeholder.
    $("#tblComboControl_" + controlId + " #tdComboControl_" + controlId).html(oComboControl.placeholder);

    // Call the update function if set and required.
    if (!isNothing(oComboControl.onChangeFunction) && fireOnChange) {
        eval(oComboControl.onChangeFunction);
    }

    // If the control list is currently open and we are not preventing closing of the list.
    if (oComboControl.listOpen) {

        // Close the list.
        comboControl_CloseList(controlId);
    }
}

function comboControl_ValidatePageSelection(e, controlId, documentId) {

    // If the enter key has been pressed.
    if (e.keyCode == 13) {

        // Get the control using the control id.
        var oComboControl = g_oaComboControls[controlId];

        // Get the document using the document id.
        var oDocument = oComboControl.documents[documentId];

        // Get the value entered into the text box.
        var szValue = $("#divComboControlList_" + controlId + " #txtComboDocumentPageSelection_" + documentId).val().trim();

        // Determine if the value is a valid selection.
        var bPageValid = false;

        // Check the value is a valid number.
        if (!isNaN(szValue)) {

            // Convert the value to a number.
            var iPageNumber = parseInt(szValue);

            // Ensure the page number is in the range of pages.
            for (var i = 0; i < oDocument.document.pages.length; i++) {

                // If this is the desired page.
                if (oDocument.document.pages[i].documentPageNumber == iPageNumber) {

                    // Get the index of the requested page.
                    var iPageIndex = comboControl_GetPageById(controlId, documentId, oDocument.document.pages[i].documentPageId, true);

		            // Perform check that our parameters are valid.
                    if (documentId != undefined && iPageIndex != undefined) {
                        // Select the requested page and set that the page number is valid.
                        comboControl_SelectOption(controlId, documentId, iPageIndex, true);
                        bPageValid = true;
                    }
                    else {
                        g_oGreenlightMessages.displayErrorBubble(g_oViewer.c_szInvalidDocument);
                    }
                }
            }
        }

        // If a valid page was not found, clear the selection.
        if (!bPageValid) {
            $("#tblComboControlList_" + controlId + " #txtComboDocumentPageSelection_" + documentId).val("");
        }
    }
}

function comboControl_FilterDocuments(controlId) {

    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];

    // Get the current filter from the list.
    var szFilter = $("#txtComboControlListFilter_" + controlId).val().trim();

    // Separate the search criteria by spaces.
    var oFilterArray = szFilter.split(' ');

    // Loop through each of the documents in the control.
    for (var i = 0; i < oComboControl.documents.length; i++) {

        // Extract the current document.
        var oDocument = oComboControl.documents[i];

		// Check if the document matches all of the search criteria.
        var bCriteriaMatchedName = true;
        var bCriteriaMatchedStatus = true;

		// Loop through each of the non-blank search criteria.
		for (var j = 0; j < oFilterArray.length; j++) {
			if (oFilterArray[j] != "") {
				// If the document does not match the filter.
				if (oDocument.documentName.toLowerCase().indexOf(oFilterArray[j].toLowerCase()) == -1) {
					// Set that the criteria was not matched.
                    bCriteriaMatchedName = false;
					break;
				}
			}
		}

		// We need to convert the greenlightApprovalDisplayStatus into the string equivalent.
		var szDocumentStatus = "";
		switch (oDocument.greenlightApprovalDisplayStatus) {
			case eApprovalStatus.Pending:
				szDocumentStatus = g_oAnnotations.c_szPending;
				break;
			case eApprovalStatus.AwaitingMyReview:
				szDocumentStatus = g_oAnnotations.c_szAwaitingMyApproval;
				break;
			case eApprovalStatus.Rejected:
				szDocumentStatus = g_oAnnotations.c_szRejected;
				break;
			case eApprovalStatus.Approved:
				szDocumentStatus = g_oAnnotations.c_szApproved;
				break;
			default:
				szDocumentStatus = null;
				break;
		}

        // Loop through each of the non-blank search criteria using the string equivalent found above.
		for (var k = 0; k < oFilterArray.length; k++) {
			if (oFilterArray[k] !== "") {
				if ((szDocumentStatus === undefined) || (szDocumentStatus === null)) {
					bCriteriaMatchedStatus = false;
				}
				// If the document does not match the filter.
				else if (szDocumentStatus.toLowerCase().indexOf(oFilterArray[k].toLowerCase()) === -1) {
                    // Set that the criteria was not matched.
                    bCriteriaMatchedStatus = false;
                    break;
                }
            }
        }

		// If the document matched all criteria.
        if (bCriteriaMatchedName || bCriteriaMatchedStatus) {
			// Make sure the document is visible in the list.
			$("#tblComboControlList_" + controlId + " #tblComboDocument_" + i).show();

            // If this document has pages and is the currently selected document.
            if (oDocument.document.pages.length > 1 && oComboControl.selectedDocumentIndex == i) {

                // Make sure the document pages are visible in the list.
                $("#tblComboControlList_" + controlId + " #divComboDocumentPages_" + i).show();
            }
        }
        // If the document did not match all criteria.
        else {

            // Make sure the document is not visible in the list.
            $("#tblComboControlList_" + controlId + " #tblComboDocument_" + i).hide();

            // If this document has pages and is the currently selected document.
            if (oDocument.document.pages.length > 1 && oComboControl.selectedDocumentIndex == i) {

                // Make sure the document pages are not visible in the list.
                $("#tblComboControlList_" + controlId + " #divComboDocumentPages_" + i).hide();
            }
        }
    }
}

function comboControl_UpdateReadOnly(controlId, readOnly) {

    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];

    // If we are making this control read only.
    if (readOnly) {

        // Remove the cursor pointer from the combo control.
        $("#divComboControl_" + controlId).css("cursor", "default");

        // Hide the drop down for the combo control.
        $("#imgComboControlDropDown_" + controlId).hide();

        // Set the control to read only.
        oComboControl.readOnly = true;
    }
    // If we are making this control editable.
    else {

        // Add the cursor pointer to the combo control.
        $("#divComboControl_" + controlId).css("cursor", "");

        // Show the drop down for the combo control.
        $("#imgComboControlDropDown_" + controlId).show();

        // Set the control to editable.
        oComboControl.readOnly = false;
    }
}

/**
 * Updates the above lock setting of the control.
 * @param {int} controlId - The id of the control.
 */
function comboControl_UpdateAboveLock(controlId) {
    
    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];

    // Ensure we have found a valid control.
    if (oComboControl == undefined) {
        return;
	}

    // If we are currently archiving a document.
    if (g_oArchive.g_ArchiveDocument > 0) {

        // Show the control above the lock.
        $("#divComboControl_" + controlId).addClass("divAboveLock");
        $("#divComboControlList_" + controlId).addClass("divAboveLock");
    }
    // If we are not currently archiving a document.
    else {

        // Do not show this control above the lock.
        $("#divComboControl_" + controlId).removeClass("divAboveLock");
        $("#divComboControlList_" + controlId).removeClass("divAboveLock");
	}
}

/*
 *	Combo Control Helpers.
 */

function comboControl_GetControlById(controlId, returnIndex) {

    // Declare a variable to hold the control.
    var oControl = null;

    // Loop through each of the controls.
    for (var i = 0; i < g_oaComboControls.length; i++) {

        // If this is the required control.
        if (g_oaComboControls[i].id == controlId) {

            // Set that this is the requested control.
            oControl = g_oaComboControls[i];

            // If we are returning the index.
            if (returnIndex) {

                // Update the return to be the index.
                oControl = i;
            }
            break;
        }
    }

    // Return the control.
    return oControl;
}

function comboControl_GetDocumentById(controlId, documentId, returnIndex) {

    // Declare a variable to hold the document.
    var oDocument = null;

    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];

    // Loop through each of the controls documents.
    for (var i = 0; i < oComboControl.documents.length; i++) {

        // If this is the required document.
        if (oComboControl.documents[i].greenlightDocumentId == documentId) {

            // Set that this is requested document.
            oDocument = oComboControl.documents[i];

            // If we are returning the index.
            if (returnIndex) {

                // Update the return to be the index.
                oDocument = i;
            }
            break;
        }
    }

    // Return the document.
    return oDocument;
}

function comboControl_GetPageById(controlId, documentId, pageId, returnIndex) {

    // Declare a variable to hold the page.
    var oPage = null;

    // Get the control using the control id.
    var oComboControl = g_oaComboControls[controlId];

    // Get the document using the document id.
    var oDocument = oComboControl.documents[documentId];

    // Loop through each of the page documents.
    for (var i = 0; i < oDocument.document.pages.length; i++) {

        // If this is the required page.
        if (oDocument.document.pages[i].documentPageId == pageId) {

            // Set that this is the requested page.
            oPage = oDocument.document.pages[i];

            // If we are returning the index.
            if (returnIndex) {

                // Update the return to be the index.
                oPage = i;
            }
            break;
        }
    }

    // Return the page.
    return oPage;
}

/**
 * Marks a document as viewed.
 * @param {any} documentId - The id of the document.
 */
function comboControl_MarkDocumentAsViewed(oDoc) {

    // Build the JSON.
    var oJSON = {
        SessionId: g_szSessionId,
        DocumentId: oDoc.documentId
    };

    // Mark the document as viewed.
    $.post({
        url: "GreenlightDocument/MarkDocumentAsViewed",
        data: JSON.stringify(oJSON),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        cache: false,
        success: function (oResponse) {

            // Ensure success.
            if (!oResponse.Success || oResponse.Errors.length > 0) {
                g_oGreenlightMessages.displayErrorBubble("Failed to mark the document as viewed.");
                return;
            }

            // Mark the document as viewed.
            oDoc.documentViewed = true;
        },
    });
}

/**
 * Gets the thumbnail path of a document.
 * @param {object} oDoc - The document.
 */
function comboControl_GetDocumentThumbnailPath(oDoc) {

    // If this document has been archived.
    if (oDoc.documentStatus == g_oArchive.g_ArchivedDocumentStatus) {
        return c_szComboControlArchivedIcon;
    }

    // If this is a threeD document.
    if (oDoc.documentType == 3 && oDoc.Approval3DViewId == 0) {
        return c_szComboControlThreeDIcon;
    }

    // Othewise we return the document thumbnail.
    return oDoc.documentThumbPath;
}

/**
 * Renders the document badge.
 * @param {object} oDoc - The document.
 */
function comboControl_RenderDocumentBadge(oDoc) {

    // If this document has been archived.
    if (oDoc.documentStatus == g_oArchive.g_ArchivedDocumentStatus) {
        return "<br/><br/><span class='comboControlListOptionBadge'>Document Archived</span>";
	}

    // No document badge.
    return "";
}

/**
 * Gets the approval id using the id of the combo control.
 * @param {string} controlId - The id of the control.
 * @returns - The approval id.
 */
function comboControl_GetApprovalIdByControlId(controlId) {

    // Get the combo control for the id.
    var oComboControl = comboControl_GetControlById(controlId, false);

    // Ensure we have a selected document index.
    if (oComboControl == null || oComboControl.selectedDocumentIndex == -1) {
        return 0;
    }

    // Return the approval id for the selected document.
    return oComboControl.documents[oComboControl.selectedDocumentIndex].greenlightApprovalId;
}

/*
 *	Combo Control Auto Closing.
 */
$(document).on('click', function (event) {

    // Loop through each of the active combo controls.
    for (var i = 0; i < g_oaComboControls.length; i++) {

        // If this combo control list is open.
        if (g_oaComboControls[i].listOpen) {

            // If the click is outside of parent combo control or the click is on combo control prompt.
            if ($(event.target).parents("#" + g_oaComboControls[i].fieldId).length == 0 ||
                $(event.target).parents("#divComboControlPrompt_" + i).length > 0 ||
                event.target.id == "divComboControlPrompt_" + i) {

                // Close the combo control.
                comboControl_CloseList(i);
            }
        }
    }
});